var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBroadcastBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0711 19.0712L18.364 18.364C21.873 14.8549 21.873 9.1452 18.364 5.63611L19.0711 4.92896C22.97 8.828 22.97 15.1721 19.0711 19.0712ZM2 15.0001H4.5V14.0001H3V10.0001H4.5V9.00006H2V15.0001ZM14 9.50006H16V14.5001H14V18.1938L5.5 15.3605V8.63965L14 5.80634V9.50006ZM13 7.19379L6.5 9.36035V14.6398L13 16.8063V7.19379ZM14 10.5001V13.5001H15V10.5001H14ZM18.3319 7.276L17.5253 7.86707C18.4083 9.07202 18.875 10.5012 18.875 12.0001C18.875 13.4988 18.4083 14.9279 17.5255 16.1328L18.3321 16.7239C19.3415 15.3463 19.875 13.7128 19.875 12.0001C19.875 10.2872 19.3414 8.65363 18.3319 7.276Z",
    fill: "#007BC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcastBlue);
export default __webpack_public_path__ + "static/media/broadcast-blue.8a71086e83f74e095655b6c0bf6887c4.svg";
export { ForwardRef as ReactComponent };